import { useCustomerTribe } from "@/hooks/useCustomerTribe";
import { useGetDetailTribe } from "@/services/api";

const useNoEligibleProductsYet = () => {
  const { data: customerTribe } = useCustomerTribe();
  const { data: tribeDetail } = useGetDetailTribe(customerTribe?.tribeId || "");

  const noEligibleProductsYet =
    !tribeDetail?.eligibleSimCount &&
    tribeDetail?.memberInfo?.some(
      (member) => member.onpEligibleSims && member.onpEligibleSims > 0,
    );

  return noEligibleProductsYet;
};

export default useNoEligibleProductsYet;
